// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-components-AiResearch-AiResearchText-ReferenceToolTip-style__referenceTooltip--tFs0a{position:relative;display:inline-block}.src-components-AiResearch-AiResearchText-ReferenceToolTip-style__referenceTooltipBubble--EvEc7{box-sizing:border-box;position:fixed;padding:16px;border-radius:4px;opacity:1;visibility:visible;z-index:0;pointer-events:none;border:1px solid #00578e;background-color:#fff;line-height:20px;word-break:break-word}", "",{"version":3,"sources":["webpack://./src/components/AiResearch/AiResearchText/ReferenceToolTip/style.scss"],"names":[],"mappings":"AACA,0FACE,iBAAA,CACA,oBAAA,CAGF,gGACE,qBAAA,CACA,cAAA,CACA,YAAA,CACA,iBAAA,CACA,SAAA,CACA,kBAAA,CACA,SAAA,CACA,mBAAA,CACA,wBAAA,CACA,qBAAA,CACA,gBAAA,CACA,qBAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.referenceTooltip {\n  position: relative;\n  display: inline-block;\n}\n\n.referenceTooltipBubble {\n  box-sizing: border-box;\n  position: fixed;\n  padding: 16px;\n  border-radius: 4px;\n  opacity: 1;\n  visibility: visible;\n  z-index: 0;\n  pointer-events: none;\n  border: 1px solid #00578e;\n  background-color: #fff;\n  line-height: 20px;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": "56px",
	"lCompanyHeight": "114px",
	"h2FontSize": "28px",
	"h3FontSize": "20px",
	"bodyLineHeight": "20px",
	"lGnShrinkWindowWidth": "1591px",
	"tableVerticalPadding": "8px",
	"tableHorizontalPadding": "16px",
	"lPersonnelBreakWidth": "1599px",
	"cNavigationAccent": "#f57f17",
	"cTableBodyOdd": "#fff",
	"cTableBodyEven": "#f2f6f8",
	"cTableHover": "#c5ddeb",
	"cTableHeadOdd": "#eaf1f5",
	"cTableHeadEven": "#dee8ef",
	"zPageLoading": "2",
	"referenceTooltip": "src-components-AiResearch-AiResearchText-ReferenceToolTip-style__referenceTooltip--tFs0a",
	"referenceTooltipBubble": "src-components-AiResearch-AiResearchText-ReferenceToolTip-style__referenceTooltipBubble--EvEc7"
};
export default ___CSS_LOADER_EXPORT___;
